import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import settingsParams from '../../components/BookOnline/settingsParams';
import stylesParams from '../../components/BookOnline/stylesParams';
import { EnrichedService } from '../../types/types';

export const showExplorePlansForService = (service: EnrichedService) =>
  service.payment?.pricingPlanIds?.length! > 0 &&
  !!service.payment?.options?.pricingPlan &&
  service?.type !== ServiceType.COURSE &&
  !service.displayOnlyNoBookFlow &&
  !service.onlineBooking?.requireManualApproval;

export const getAtLeastOneServiceHasExplorePlansLink = ({
  flowAPI,
  services,
  isPricingPlanInstalled,
}: {
  flowAPI: ControllerFlowAPI;
  services: EnrichedService[];
  isPricingPlanInstalled: boolean;
}): boolean =>
  isPricingPlanInstalled &&
  flowAPI.settings.get(settingsParams.isExplorePlansVisible) !== false &&
  flowAPI.controllerConfig.config.allStyles.some(
    (style) =>
      style.booleans[stylesParams.isExplorePlansVisible.key!] !== false,
  ) &&
  services.some(showExplorePlansForService);
